import { useAxios } from "@hooks";
import { useQuery } from "@tanstack/react-query";
import { ExamAnswerAuditLog } from "@types";
import { AxiosError } from "axios";

/**
 * Dohvaća audit zapise predaja odgovora polaznika za instancu ispita.
 * Endpoint je na backendu zaštićen permisijom ANSWER_AUDIT_READ (samo Admin +
 * Assessor). Hook se omogućuje (`enabled`) tek kad pozivatelj potvrdi da
 * korisnik ima odgovarajuću rolu, da se za ostale uopće ne radi poziv.
 */
export const useGetAnswerAuditLogs = (
  examInstanceId: string | undefined,
  options?: { enabled?: boolean }
) => {
  const axios = useAxios();

  return useQuery<ExamAnswerAuditLog[]>({
    queryKey: ["answerAuditLogs", examInstanceId],
    queryFn: async () => {
      try {
        const response = await axios.get<ExamAnswerAuditLog[]>(
          `/api/examinstancequestion/AnswerAudit/${examInstanceId}`
        );
        return response.data;
      } catch (error) {
        const axiosError = error as AxiosError;
        if (axiosError.response?.status === 404) {
          return [];
        }
        throw error;
      }
    },
    enabled: !!examInstanceId && options?.enabled === true,
    staleTime: 30000,
  });
};

export default useGetAnswerAuditLogs;
